import {Enum} from 'enumify';

export default class RefundReasonType extends Enum {}

RefundReasonType.initEnum({
  DUPLICATE: {
    title: 'Duplicate',
    value: 'duplicate',
  },
  FRAUDULENT: {
    title: 'Fraudulent',
    value: 'fraudulent',
  },
  REQUESTED_BY_CUSTOMER: {
    title: 'Requested by customer',
    value: 'requested_by_customer',
  },
  MISTAKE_BY_MANAGER: {
    title: 'Mistake by manager',
    value: 'mistake_by_manager',
  },

});



// WEBPACK FOOTER //
// ./src/constants/RefundReasonType.js